module.exports = __webpack_public_path__ + "img/left.64a940b3.gif";